export default "__VITE_ASSET__77bf8d32__"